import React from "react";

export const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full h-screen bg-navbar flex justify-center items-center p-4"
    >
      <form
        method="POST"
        action="https://getform.io/f/381a716c-c934-4719-b3e9-8dc8b743e143"
        className="flex flex-col max-w-[600px] w-full"
      >
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-pink-600 text-gray-300">
            Contact
          </p>
          <p className="text-gray-300 py-4">
            Submit the form below or shoot me an email - dkamat.001@gmail.com
          </p>
        </div>
        <input
          required
          className="bg-input p-2"
          type="text"
          placeholder="Name"
          name="name"
        />
        <input
          required
          className="my-4 p-2 bg-input"
          type="email"
          placeholder="Email"
          name="email"
        />
        <textarea
          className="bg-input p-2"
          name="message"
          rows="10"
          placeholder="Message"
        ></textarea>
        <button className="text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-8 mx-auto flex items-center">
          Let's Collaborate
        </button>
      </form>
    </div>
  );
};
